import React from 'react';

interface LoadingSpinnerProps {
  /** Size in pixels. Default: 40 */
  size?: number;
  /** Accessible label. Default: "Loading" */
  label?: string;
}

/**
 * Simple CSS-based loading spinner.
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  label = 'Loading',
}) => {
  return (
    <div
      role="status"
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          border: '3px solid #e5e7eb',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span className="sr-only" style={{ position: 'absolute', clip: 'rect(0,0,0,0)' }}>
        {label}
      </span>
    </div>
  );
};
